module.exports = __webpack_public_path__ + "media/images/menuIcon-c500e90a.svg";